// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"471":"99efc129","579":"056a2132","787":"cda612ba","952":"0a1899e1"}[chunkId] + ".chunk.js";
};